<script setup lang="ts">
import type { FetchError } from "ofetch";

interface ErrorMap {
	title: string
	message: string
	details: string
}

const props = defineProps({
	error: {
		type: Object as PropType<FetchError | Ref<FetchError>>,
		required: true
	},
	caughtInErrorBoundary: {
		type: Boolean,
		default: false
	}
});
const emit = defineEmits(["clear-error"]);

if (props.caughtInErrorBoundary) {
	const router = useRouter();
	router.afterEach(() => {
		emit("clear-error");
	});
}

const statusCodeTitleMapping = new Map<number, ErrorMap>();
statusCodeTitleMapping.set(404,
	{
		title: "404",
		message: "Page not found",
		details: "Sorry, we couldn't find the page you where looking for. We suggest that you return to home page."
	}
);

const getErrorMessage = computed(() => {
	const error = toValue(props.error);

	if (error.statusCode) {
		if (!statusCodeTitleMapping.has(error.statusCode)) {
			return {
				title: error.statusCode,
				message: error.message,
				details: error.stack
			};
		}

		return statusCodeTitleMapping.get(error.statusCode) as ErrorMap;
	} else {
		return {
			title: "",
			message: "",
			details: ""
		};
	}
});

const navigateAndClearError = async () => {
	if (props.caughtInErrorBoundary) {
		await navigateTo("/");
	}
	emit("clear-error");
};
</script>

<template>
	<div class="max-w-[476px] m-auto flex flex-col items-center justify-center">
		<div class="text-[100px] font-bold">
			{{ getErrorMessage.title }}
		</div>
		<div class="text-2xl">
			{{ getErrorMessage.message }}
		</div>
		<div class="mt-5 text-md text-center">
			{{ getErrorMessage.details }}
		</div>
		<AppButton
			class="mt-5"
			wide
			fill
			@click="navigateAndClearError"
		>
			Go back
		</AppButton>
	</div>
</template>
